import React, { Component } from "react";
import Styles from "./styles/js/style";
import cookie from "react-cookies";

class GDPR extends Component {
  state = {
    agreed: ""
  };
  onButtonHover = e => {
    const t = document.getElementById(e.target.id);
    if (e.target.id === "iagree") {
      t.style.color = "#fff";
      t.style.backgroundColor = "#668600";
    } else if (e.target.id === "privacy") {
      t.style.color = "#f47d20";
      t.style.borderBottom = "1px dashed #f47d20";
    }
  };

  onButtonOut = e => {
    const t = document.getElementById(e.target.id);
    if (e.target.id === "iagree") {
      t.style.color = "#000";
      t.style.backgroundColor = "#a7d233";
    } else if (e.target.id === "privacy") {
      t.style.color = "#000";
      t.style.borderBottom = "1px dashed #444";
    }
  };
  onButtonPush = e => {
    const expires = new Date();
    expires.setDate(100);
    cookie.save("cookie-agreed", 2, {
      path: "/",
      expires,
      host: "https://*.uvm.edu"
    });
    const t = document.getElementById("gdprBlock");
    t.parentNode.removeChild(t);
  };
  componentWillMount() {
    this.setState({ agreed: cookie.load("cookie-agreed") });
  }
  render() {
    if (!this.state.agreed) {
      return (
        <div
          className="gdprBlock"
          id="gdprBlock"
          style={{
            ...Styles.gdprBlock
          }}
        >
          <div
            style={{
              maxWidth: "1200px",
              marginLeft: "auto",
              marginRight: "auto"
            }}
          >
            <div
              className="textBlock"
              style={{
                ...Styles.textBlock
              }}
            >
              We use cookies on our website to support technical features that
              enhance your user experience, and help us improve our website. By
              continuing to use this website, you accept our{" "}
              <a
                onMouseOver={this.onButtonHover}
                onMouseOut={this.onButtonOut}
                id="privacy"
                style={{ ...Styles.link }}
                href="https://www.uvm.edu/compliance/website-privacy-policy/terms-use"
              >
                privacy policy.
              </a>
              <br />
              <button
                onMouseOver={this.onButtonHover}
                onMouseOut={this.onButtonOut}
                onClick={this.onButtonPush}
                className="iagree"
                id="iagree"
                style={{ ...Styles.button }}
              >
                I Understand
              </button>
            </div>
          </div>
        </div>
      );
    } else return null;
  }
}

export default GDPR;
